import React from "react";
import { Tab } from "semantic-ui-react";
import CreateCourses from "../Cursos/CreateCourses";
import ListCursos from "../Cursos/ListCursos";
import Footer from "../Footer";
import CreateRoles from "../Roles/CreateRoles";
import FormsCC from "./FormsCC";
import AsignarRolUser from "../Roles/asignarRoles";
import ListRoles from "../Roles/ListRoles";
import "./config.css";

const panes = [
  {
    menuItem: "Cuenta Corriente",
    render: () => (
      <Tab.Pane attached={false}>
        {" "}
        <FormsCC />{" "}
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Crear Cursos",
    render: () => (
      <Tab.Pane attached={false}>
        <CreateCourses />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Editar Cursos",
    render: () => (
      <Tab.Pane attached={false}>
        <ListCursos />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Crear Roles",
    render: () => (
      <Tab.Pane attached={false}>
        <CreateRoles />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Asignar Roles",
    render: () => (
      <Tab.Pane atttached={false}>
        <AsignarRolUser />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Editar roles",
    render: () => (
      <Tab.Pane atttached={false}>
        <ListRoles />
      </Tab.Pane>
    ),
  },
];

export default function Configuracion() {
  return (
    <div style={{ backgroundColor: "white" }}>
      <br></br>
      <br></br>
      <div style={{ maxWidth: "1324px", margin: "auto", marginBottom: "50px" }}>
        <Tab panes={panes} />
      </div>
      <Footer />
    </div>
  );
}
